const registerAnimations = () => {
    const $ = window.$;
    
    var windowHeight = window.innerHeight;
    var windowWidth = window.innerWidth;
    var prepare = windowHeight/3;
    
    // sec2
    $(document).ready(function(){
        var windowScroll = $(window).scrollTop();

        if($('.sec2 .figure').length){
            var sec2 = $('.sec2 .figure').offset().top;
            
            if((windowScroll + windowHeight -  prepare*2) > sec2){
                $('.sec2 .shoe-colors').addClass('animate');
            }
            $(window).on('scroll', function(){
                    windowScroll = $(window).scrollTop();
                    sec2 = $('.sec2').offset().top;	
                    if((windowScroll + windowHeight -  prepare*1.99) > sec2){
                        $('.sec2 .shoe-colors').addClass('animate');
                    }
                
            });
        }
    });

    // sec3
    prepare = windowHeight/3;

    $(document).ready(function(){
        var windowScroll = $(window).scrollTop();
        if($('.sec3').length){
            var footbed = $('.sec3').offset().top;
            
            if((windowScroll + windowHeight -  prepare*2) > footbed){
                $('.sec3 .shoe').addClass('fadeInRight');
                $('.sec3 .feather').addClass('fadeInDown');
            }
            $(window).on('scroll', function(){
                    windowScroll = $(window).scrollTop();
                    footbed = $('.sec3').offset().top;	
                    if((windowScroll + windowHeight -  prepare*1.5) > footbed){
                        $('.sec3 .shoe').addClass('fadeInRight');
                        $('.sec3 .feather').addClass('fadeInDown');
                    }
                  // console.log(footbed);
                    
                
            });
        }
    });

    // sec 5
    prepare = windowHeight/4;
    $(document).ready(function(){
      var windowScroll = $(window).scrollTop();

      if($('#slipper-animation').length){
            $(window).on('scroll', function(){
                var slipper = $('#slipper-animation').offset().top;
                
                var slipperScrollUpTO = 215; 
                if(windowWidth >= 375 && windowWidth < 410){
                    slipperScrollUpTO = 250;
                }
                if(windowWidth >= 410 && windowWidth < 480){
                    slipperScrollUpTO = 300;
                }
                if(windowWidth >= 480 && windowWidth < 768){
                    slipperScrollUpTO = 350;
                }
                if(windowWidth >= 768 && windowWidth < 1200){
                    slipperScrollUpTO = 350;
                }
                if(windowWidth >= 1200 && windowWidth < 1440){
                    slipperScrollUpTO = 450;
                }
                if(windowWidth >= 1440 && windowWidth < 1600){
                    slipperScrollUpTO = 520;
                }
                if(windowWidth >= 1600){
                    slipperScrollUpTO = 580;
                }

                windowScroll = $(window).scrollTop();
                //console.log(windowScroll);
        
                
                
                var slipperScroll = windowScroll + windowHeight - slipper - prepare - 50;
                if((windowScroll + windowHeight - prepare ) > slipper && slipperScroll > 0){
                    //console.log(windowScroll);
                    if(slipperScroll <= slipperScrollUpTO){
                        $("#layer-inside").css({'transform': 'translateY('+slipperScroll/2.5+'px)',});
                        $("#layer-bottom").css({'transform': 'translateY('+slipperScroll/1.7+'px)',});
                        $("#layer-base").css({'transform': 'translateY('+slipperScroll/1.5+'px)',});
                    }else{
                        //console.log("slipperScrollUpTO : " + slipperScrollUpTO + " | slipperScroll : " + slipperScroll);
                        
                    }
                }else{
                    $("#layer-inside").css({'transform': 'translateY('+0+'px)',});
                    $("#layer-bottom").css({'transform': 'translateY('+0+'px)',});
                    $("#layer-base").css({'transform': 'translateY('+0+'px)',});
                }

            });
        }
    });

    // sec6
    prepare = windowHeight/3;
    
    $(document).ready(function(){
        var windowScroll = $(window).scrollTop();
        if($('.sec6').length){
            var sec6 = $('.sec6').offset().top;
            
            if((windowScroll + windowHeight -  prepare*2) > sec6){
                $('.sec6 .animated').addClass('fadeInRight');
            }
            $(window).on('scroll', function(){
                    windowScroll = $(window).scrollTop();
                    sec6 = $('.sec6').offset().top;	
                    if((windowScroll + windowHeight -  prepare*1.25) > sec6){
                        $('.sec6 .animated').addClass('fadeInRight');
                    }
                    //console.log(sec6);
                    
                
            });
        }
    });

    // sec7
    prepare = windowHeight/3;

    $(document).ready(function(){
        var windowScroll = $(window).scrollTop();
        if($('.sec7').length){
            var footbed = $('.sec7').offset().top;
            
            if((windowScroll + windowHeight -  prepare*2) > footbed){
                $('.sec7 .comfort-2').addClass('fadeInUp');
                $('.sec7 .comfort-1').addClass('fadeInDown');
            }
            $(window).on('scroll', function(){
                    windowScroll = $(window).scrollTop();
                    footbed = $('.sec7').offset().top;	
                    if((windowScroll + windowHeight -  prepare*1.5) > footbed){
                        $('.sec7 .comfort-2').addClass('fadeInUp');
                        $('.sec7 .comfort-1').addClass('fadeInDown');
                    }
                  // console.log(footbed);
                    
                
            });
        } 
    });

    // sec8
    prepare = windowHeight/3;

    $(document).ready(function(){
        var windowScroll = $(window).scrollTop();
        if($('.sec8').length){
            var sec8 = $('.sec8').offset().top;
            
            if((windowScroll + windowHeight -  prepare*2) > sec8){
                $('.sec8 .animated').addClass('fadeInLeft');
            }
            $(window).on('scroll', function(){
                    windowScroll = $(window).scrollTop();
                    sec8 = $('.sec8').offset().top;	
                    if((windowScroll + windowHeight -  prepare*1.5) > sec8){
                        $('.sec8 .animated').addClass('fadeInLeft');
                    }
                    //console.log(sec8);
                    
                
            });
        }
    });

    // sec9
    prepare = windowHeight/3;

    $(document).ready(function(){
        var windowScroll = $(window).scrollTop();
        if($('.sec9').length){
            var footbed = $('.sec9').offset().top;
            
            if((windowScroll + windowHeight -  prepare*2) > footbed){
                $('.sec9 .shoe').addClass('fadeInRight');
                $('.sec9 .shoe-water-1').addClass('fadeIn');
                $('.sec9 .shoe-water-2').addClass('fadeIn');
            }
            $(window).on('scroll', function(){
                    windowScroll = $(window).scrollTop();
                    footbed = $('.sec9').offset().top;	
                    if((windowScroll + windowHeight -  prepare*1.5) > footbed){
                        $('.sec9 .shoe').addClass('fadeInRight');
                        $('.sec9 .shoe-water-1').addClass('fadeIn');
                        $('.sec9 .shoe-water-2').addClass('fadeIn');
                    }
                  // console.log(footbed);
                    
                
            });
        }
    });
}

export default registerAnimations;